import { Changes } from "../base/Changes";

export class ReplacementClaimAppliance {
  public id: number;
  public replacementClaimId: number;
  public applianceCategoryId: number;
  public applianceCategory: string;
  public description?: string;
  public hOID?: string;
  public changes: Changes;

  constructor(appliance: {
    id: number;
    replacementClaimId: number;
    applianceCategoryId: number;
    applianceCategory: string;
    description?: string;
    hOID?: string;
    changes: Changes;
  }) {
    this.id = appliance.id;
    this.replacementClaimId = appliance.replacementClaimId;
    this.applianceCategoryId = appliance.applianceCategoryId;
    this.applianceCategory = appliance.applianceCategory;
    this.description = appliance.description;
    this.hOID = appliance.hOID;
    this.changes = appliance.changes;
  }
}
